import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from "@material-ui/core";
import { useEffect, useState } from "react";
import {
  getFanDataByForeignKey,
  reparentFan,
} from "../app/reducer/fan.reducer";
import { useDispatch } from "react-redux";
import Paths from "../utils/Paths";
import {
  getHubModels,
  removeNewHubModel,
} from "../app/reducer/hubModal.reducer";
import {
  getBladeModels,
  removenewBladeModel,
} from "../app/reducer/bladeModal.reducer";
import { getGADrawingModel, removeGADrawingModel } from "../app/reducer/gaDrawingModal.reducer";
import {
  getOctaveBandsModels,
  removeOctaveBandModel,
} from "../app/reducer/octaveBandModal.reducer";

enum DeleteType {
  Delete,
  ReParentAndDelete,
  Loading,
}

const ButtonTextMapping = {
  [Paths.BladeModel]: "Delete Blade",
  [Paths.GaDrawing]: "Delete GA Drawing",
  [Paths.OctaveBand]: "Delete Octave Band",
  [Paths.Hub]: "Delete Hub",
};

const DeleteData = ({
  handleClose,
  path,
  deleteElementId,
  handleDelete,
}: any) => {
  return (
    <>
      <DialogTitle>Delete</DialogTitle>
      <DialogContent>
        <TextField
          fullWidth={true}
          label={path.toUpperCase()}
          id="standard-basic"
          value={deleteElementId}
          disabled={true}
        />
      </DialogContent>
      <DialogActions>
        <Button type="button" onClick={handleClose}>
          Cancel
        </Button>
        <Button type="button" onClick={handleDelete}>
          {ButtonTextMapping[path]}
        </Button>
      </DialogActions>
    </>
  );
};

const ReparentDeleteData = ({
  handleClose,
  path,
  listOfAssociatedFans,
  deleteElementId,
  handleDelete,
}: any) => {
  const [replacementList, setReplacementList] = useState([]);
  const [replacementValue, setReplacementValue] = useState<any>("");
  const dispatch = useDispatch();
  useEffect(() => {
    populateData();
  }, []);

  const populateData = async () => {
    let listOfElements = [];
    switch (path) {
      case Paths.Hub:
        const hubList: any = await dispatch(getHubModels());
        listOfElements = hubList.payload.data.map((hub: any) => {
          return {
            path: "hub",
            id: hub._id,
            text: hub.hubID,
            reference_id: hub.hubID,
          };
        });
        break;
      case Paths.BladeModel:
        const bladeList: any = await dispatch(getBladeModels());
        listOfElements = bladeList.payload.data.map((blade: any) => {
          return {
            path: "bladeModel",
            id: blade._id,
            text: blade.bladeModelID,
            reference_id: blade.bladeModelID,
          };
        });
        break;
      case Paths.GaDrawing:
        const gaDrawingList: any = await dispatch(getGADrawingModel());
        listOfElements = gaDrawingList.payload.data.map((gaDrawing: any) => {
          return {
            path: "gaDrawing",
            id: gaDrawing._id,
            text: gaDrawing.gaDrawingID,
            reference_id: gaDrawing.gaDrawingID,
          };
        });
        break;
      case Paths.OctaveBand:
        const octaveList: any = await dispatch(getOctaveBandsModels());
        listOfElements = octaveList.payload.data.map((octave: any) => {
          return {
            path: "octaveBand",
            id: octave._id,
            text: octave.octaveBandID,
            reference_id: octave.octaveBandID,
          };
        });
        break;
    }
    listOfElements = listOfElements.filter(
      (element: any) => element.reference_id !== deleteElementId
    );
    setReplacementValue(listOfElements[0].id);
    setReplacementList(listOfElements);
  };

  const executeReparentDelete = async () => {
    const fanList = listOfAssociatedFans.map((fan: any) => fan._id);
    await dispatch(
      reparentFan({
        fanObjectIdList: fanList,
        path: path,
        pathValue: replacementValue,
      })
    );
    handleDelete();
  };

  return (
    <>
      <DialogTitle>Delete</DialogTitle>
      <DialogContent>
        <TextField
          fullWidth={true}
          label={path.toUpperCase()}
          id="standard-basic"
          value={deleteElementId}
          disabled={true}
        />
        <FormControl fullWidth={true}>
          <InputLabel>List of connected fans.</InputLabel>
          <Select>
            {listOfAssociatedFans.map((fan: any) => {
              return <MenuItem value={fan._id}>{fan.fanModelID}</MenuItem>;
            })}
          </Select>
        </FormControl>
        <FormControl fullWidth={true}>
          <InputLabel>Replacement {path}</InputLabel>
          <Select
            value={replacementValue}
            onChange={(event) => setReplacementValue(event.target.value)}
          >
            {replacementList.map((element: any) => {
              return <MenuItem value={element.id}>{element.text}</MenuItem>;
            })}
          </Select>
        </FormControl>
      </DialogContent>

      <DialogActions>
        <Button type="button" onClick={handleClose}>
          Cancel
        </Button>
        <Button type="button" onClick={executeReparentDelete}>
          {ButtonTextMapping[path]}
        </Button>
      </DialogActions>
    </>
  );
};

const DeleteDialog = ({
  open,
  handleClose,
  path,
  idType,
  id,
  handleDelete,
}: any) => {
  const [deleteType, setDeleteType] = useState<DeleteType>(DeleteType.Loading);
  const [listOfAssociatedFans, setListOfAssociatedFans] = useState([]);
  const dispatch = useDispatch();
  useEffect(() => {
    getDeleteType();
  }, [open]);

  const getDeleteType = async () => {
    setDeleteType(DeleteType.Loading);
    if (!open || id == null || id === undefined || id.length == 0) return;
    const response: any = await dispatch(
      getFanDataByForeignKey({ path, idType, id })
    );
    setListOfAssociatedFans(response.payload);
    setDeleteType(
      response.payload.length > 0
        ? DeleteType.ReParentAndDelete
        : DeleteType.Delete
    );
  };

  const deleteElement = async () => {
    switch (path) {
      case Paths.Hub:
        await dispatch(removeNewHubModel({ hubID: id }));
        break;
      case Paths.GaDrawing:
        await dispatch(removeGADrawingModel({ gaDrawingID: id }));
        break;
      case Paths.OctaveBand:
        await dispatch(removeOctaveBandModel({ octaveBandID: id }));
        break;
      case Paths.BladeModel:
        await dispatch(removenewBladeModel({ bladeModelID: id }));
        break;
    }
    handleDelete();
  };

  return (
    <>
      <Dialog open={open} onClose={handleClose} fullWidth={true} maxWidth="sm">
        {deleteType === DeleteType.Delete && (
          <DeleteData
            handleClose={handleClose}
            path={path}
            deleteElementId={id}
            handleDelete={deleteElement}
          />
        )}
        {deleteType === DeleteType.ReParentAndDelete && (
          <ReparentDeleteData
            handleClose={handleClose}
            path={path}
            listOfAssociatedFans={listOfAssociatedFans}
            deleteElementId={id}
            handleDelete={deleteElement}
          />
        )}
      </Dialog>
    </>
  );
};

export default DeleteDialog;
